import React, { useEffect, useState } from 'react';
import FilledInput from '@material-ui/core/FilledInput';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { clearCookie, setCookie, getUserDetails, isLogin } from '../../functions/Auth';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import Cookies from 'js-cookie';
import '../../scss/components/_my_profile.scss';

import API_PATH from "../../constants/config.json";

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

//Start SignIn component code ...
const MyProfile = (props) => {
    let history = useHistory();
    const [passwordValues, setPasswordValues] = React.useState({
      currentpwd: "",
      newpwd: "",
      cnfNewPwd: ""
    });
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [currentPassword, setCurrentPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [assignedTeams, setAssignedTeams] = React.useState([]);
    const [userDetails, setUserDetails] = React.useState([]);
  
    const [firstName, setFirstName] = React.useState(Cookies.get('firstName'));
    const [lastName, setLastName] = React.useState(Cookies.get('lastName'));
    const [organization, setOrganization] = React.useState(Cookies.get('organization'));
  
    const [initialFirstName, setInitialFirstName] = React.useState(Cookies.get('firstName'));
    const [initialLastName, setInitialLastName] = React.useState(Cookies.get('lastName'));
    const [initialOrganization, setInitialOrganization] = React.useState(Cookies.get('organization'));
  
    const [profileErr, setProfileErr] = React.useState(false);
    const [passwordErr, setPasswordErr] = React.useState(false);

    const [errFirstName, setErrFirstName] = useState(null);
    const [errLastName, setErrLastName] = useState(null);
    const [errMsgNotEmpty, setErrMsgNotEmpty] = useState(null);
    const [errCurrentPwd, setErrCurrentPwd] = useState(null);
    const [errMsgInvalidPwd, setErrMsgInvalidPwd] = useState(null);

    const [validLen, setValidLen] = useState(false);
    const [validNum, setValidNum] = useState(false);
    const [validUpper, setValidUpper] = useState(false);
    const [validLower, setValidLower] = useState(false);
    const [validSpecialCh, setValidSpecialCh] = useState(false);
    const [validPwd, setValidPwd] = useState(false);

    const [errPopUpPwd, setErrPopUpPwd] = React.useState(false);
    const [errMsgPwd, setErrMsgPwd] = React.useState(null);
    const [errMsgTypePwd, setErrMsgTypePwd] = React.useState('error');
    const [msgTitle, setMsgTitle] = useState(null);
    const [msgPwdTitle, setMsgPwdTitle] = useState(null);

    let vPwd = false;
  
    useEffect(
      () => {
        getTeamsAssigned();
      }, [])
  
    const ShowErrPopUP = () => {
      setErrPopUp(false)
    };

    const ShowErrPopUPPwd = () => {
        setErrPopUpPwd(false)
      };
  
    const profileHandleChange = name => event => {
      if (name == 'first_name') {
        setFirstName(event.target.value);
        if(event.target.value === '') {
            setErrFirstName(true);
            setErrMsgNotEmpty('Can not be empty')
        } else {
            setErrFirstName(null);
        }
      } else if (name == 'last_name') {
        setLastName(event.target.value)
        if(event.target.value === '') {
            setErrLastName(true);
            setErrMsgNotEmpty('Can not be empty')
        } else {
            setErrLastName(null);
        }
      } else if (name == 'organization') {
        setOrganization(event.target.value);
      }
    }
  
    //This code use for update user profile .... start
    const updateMyProfile = async () => { 
      setProfileErr(false);
      setPasswordErr(false);
      setErrMsg(null);
      setMsgTitle(null);
      if (userDetails && userDetails.user_id) {
        let data = { "userId": userDetails.user_id, 'email':Cookies.get('email'), 'first_name': firstName, 'last_name': lastName, 'organization': organization }
        try {
          axios({
            method: 'post',
            data: data,
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.updateMyProfileAPI,         
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                await setCookie('firstName', response.data.data.first_name);
                await setCookie('lastName', response.data.data.last_name);
                await setCookie('organization', response.data.data.organization);
                setInitialFirstName(response.data.data.first_name);
                setInitialLastName(response.data.data.last_name);
                setInitialOrganization(response.data.data.organization);
                setErrMsgType('custom_success');
                setMsgTitle('Saved successfully');
                setErrMsg('--');
                setErrPopUp(true);
              } else {
                setErrMsgType('error')
                setErrMsg('Something went wrong.');
                setErrPopUp(true);
                setProfileErr(true);
              }
            })
            .catch(async function (error) {
              if (error.response) {
                if (error.response.status == '401') {
                  if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('atexpiry');
                  }
                  history.push('/');
                } else {
                  setErrMsgType('error')
                  setErrMsg(error.response.data.message);
                  setErrPopUp(true);
                  setProfileErr(true);
                }             
              } else {
                setErrMsgType('error')
                setErrMsg('Something went wrong.');
                setErrPopUp(true);              
                setProfileErr(true);
              }
            })
        } catch (error) {
          console.error(error);
        }
      } else {
        if (Cookies.get('email')) {
          clearCookie('email');
          clearCookie('payload');
          clearCookie('idToken');
          clearCookie('atexpiry');
        }
        history.push('/');
      }
    }
    //This code use for update user profile .... end
  
    const passwordHandleChange = name => event => {
        let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`])[A-Za-z\d\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`]{8,}$/
        let val = event.target.value;
        if (name == 'currentpwd') {
            setCurrentPassword(val);
        } else if (name == 'newpwd') {
            let tmp = val.length >= 8 ? true : false;
            setValidLen(tmp);
            setValidNum((/\d/).test(val));
            setValidUpper((/[A-Z]/).test(val));
            setValidLower((/[a-z]/).test(val));
            setValidSpecialCh((/[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`]/).test(val));

            vPwd = passwordCheck.test(val);
            setValidPwd(vPwd);
            setNewPassword(val);
        } 
        setPasswordValues({ ...passwordValues, [name]: val });
    }
  
    const clearPasswordForm = () => {
      setCurrentPassword('');
      setNewPassword('');
      props.checkValue();
    }
  
    //This code is use for change password API call ... start
    const changePassword = async () => { 
      setProfileErr(false);
      setPasswordErr(false);
      setErrMsgPwd(null);
      setMsgPwdTitle(null);
      setErrCurrentPwd(null);
      if (isLogin()) {
        try {
          axios({
            method: 'post',
            data: { ...passwordValues },
            url: API_URL + API_PATH.changePasswordAPIv2,
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                setErrMsgTypePwd('custom_success');
                setMsgPwdTitle('Password update complete');
                setErrMsgPwd('Password successfully changed.');
                setErrPopUpPwd(true);
                setCurrentPassword('');
                setNewPassword('');
                setValidLen(false);
                setValidNum(false);
                setValidPwd(false);
                setValidSpecialCh(false);
                setValidUpper(false);
                setValidLower(false);
                setPasswordValues(
                  {
                    currentpwd: "",
                    newpwd: ""
                  }
                )
              } else {
                setErrMsgTypePwd('error')
                setErrMsgPwd('Something went wrong.');
                setErrPopUpPwd(true)
                setPasswordErr(true)
              }
            })
            .catch(async function (error) {
              if (error.response) {
                if (error.response.status == '401') {
                  if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('atexpiry');
                    clearCookie('alLogIn');
                  }
                  history.push('/');
                } else {
                  let msg = error.response.data.message.message;
                  if(msg === 'Incorrect password') {
                    setErrCurrentPwd(true);
                    setErrMsgInvalidPwd(msg);
                  } else {
                    setErrMsgTypePwd('error');
                    setErrMsgPwd(error.response.data.message.message);
                    setErrPopUpPwd(true)
                    setPasswordErr(true)
                  }
                }
              } else {
                setErrMsgTypePwd('error')
                setErrMsgPwd('Something went wrong.');
                setErrPopUpPwd(true)
                setPasswordErr(true)
              }
            })
        } catch (error) {
          console.error(error);
        }
      } else {
        if (Cookies.get('email')) {
          clearCookie('email');
          clearCookie('payload');
          clearCookie('idToken');
          clearCookie('atexpiry');
          clearCookie('alLogIn');
        }
        history.push('/');
      }
    }
    //This code is use for change password API call ... end
  
  
    //This method is use for get user details ... start
    const getTeamsAssigned = async () => {
      let details = await getUserDetails(); 
      setUserDetails(details)
      try {
        axios({
          method: 'post',
          data: { 'userId': details.user_id },
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.getAssignedTeamAPI,
        })
          .then(function (response) {
            setAssignedTeams(response.data.data);
          })
          .catch(function (error) {
            setAssignedTeams([]);
          })
      } catch (error) {
        console.error(error);
      }
    }
    //This method is use for get user details ... end

    const validateForm = (e) => {
        e.preventDefault();
        if(initialFirstName !== firstName || initialLastName !== lastName || initialOrganization !== organization) {
            updateMyProfile();
        }

        if(currentPassword !== '' && newPassword !== '' && validPwd) {
            changePassword();
        }
    }

    const handleCloseProfile = () => {
        props.checkValue();
    }

  return (
    <React.Fragment>
      <CssBaseline />
      <div className="myprofile-main">
        <Container className="myprofile-container" maxWidth="lg">
            <form className="myprofile-form" noValidate autoComplete="off" onSubmit={e => validateForm(e)} >
              <img src={require('../../assets/icons/close.svg')} className="close-icon-profile" onClick={handleCloseProfile} />
              <Grid container spacing={3} className="margin-0">
                {/* Profile */}
                <Grid item xs={7} className="padding-right-24 vertical-divisor padding-left-side">
                    <label>Profile</label>
                    <p>Basic information about you, the teams you are on and your password.</p>
                    {errMsg ? <ErrorMessage title={msgTitle} message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> : null}
                    <Grid container spacing={1} className="horizontal-divisor">
                        <Grid xs={6} item>
                        <Paper className="paper" >
                            <p className="text-input-label">First name</p>
                            <FilledInput 
                            id="first_name" 
                            className={errFirstName ? "form-text-input-error" : "form-text-input"} 
                            type="text" variant="outlined" required 
                            value={firstName} 
                            onChange={profileHandleChange('first_name')}
                            data-testid='first_name'  
                            endAdornment={ errFirstName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                            />
                            {errFirstName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                        </Paper>
                        </Grid>
                        <Grid xs={6} item>
                        <Paper className="paper" >
                            <p className="text-input-label">Last name</p>
                            <FilledInput 
                            id="last_name" 
                            className={errLastName ? "form-text-input-error" : "form-text-input"} 
                            type="text" variant="outlined" required 
                            value={lastName} 
                            onChange={profileHandleChange('last_name')}
                            data-testid='last_name'  
                            endAdornment={ errLastName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                            />
                            {errLastName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                        </Paper>
                        </Grid>
                        <Grid xs={6} item>
                        <Paper className="paper" >
                            <p className="text-input-label">Email address</p>
                            <FilledInput 
                            id="email" 
                            className="form-text-input"
                            type="email" variant="outlined" 
                            value={Cookies.get('email') ? Cookies.get('email') : ''}
                            data-testid='email'  
                            disabled={true}
                            />
                        </Paper>
                        </Grid>
                        <Grid xs={6} item style={{position: 'relative'}}>
                            <Paper className="paper" >
                                <p className="text-input-label">Organization</p>
                                <FilledInput 
                                id="organization" 
                                className="form-text-input" 
                                type="text" variant="outlined"
                                value={organization}
                                onChange={profileHandleChange('organization')}
                                data-testid='organization'  
                                />
                            </Paper>
                            <label className="optional-lbl">Optional</label>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <label>Teams</label>
                        <p style={{marginBottom: '16px'}}>Organizations that you are associated with.</p>
                        <TableContainer component={Paper}  className="table-properties">
                            <Table className="table-teams" aria-label="customized table">
                            <TableHead>
                                <StyledTableRow>
                                    <TableCell>Team name</TableCell>
                                    <TableCell>Permission level</TableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                { 
                                    (assignedTeams && assignedTeams.length > 0) && assignedTeams.map(function(item, i){
                                        return (<StyledTableRow>
                                            <TableCell>
                                            {userDetails ? userDetails.agencyname : null}
                                            </TableCell>
                                            <TableCell>
                                            {item.team_name}
                                            </TableCell>
                                        </StyledTableRow>)      
                                    })
                                }
                            </TableBody>
                            </Table>
                        </TableContainer> 
                    </Grid>
                </Grid>
                {/* Password */}
                <Grid item xs={5} className="padding-left-24 padding-right-side">
                    <label>Password</label>
                    <p>Change your password to something new.</p>
                    {errMsgPwd ? <ErrorMessage message={errMsgPwd} title={msgPwdTitle} visible={ShowErrPopUPPwd} show={errPopUpPwd} msgType={errMsgTypePwd} /> : null}
                    <Grid container spacing={1}>
                        <Grid xs={12} item>
                            <Paper className="paper" >
                                <p className="text-input-label">Current password</p>
                                <FilledInput 
                                id="current_password" 
                                className={errCurrentPwd ? "form-text-input-error" : "form-text-input"} 
                                type="password" variant="outlined"
                                value={currentPassword}
                                onChange={passwordHandleChange('currentpwd')}
                                data-testid='current_password'  
                                endAdornment={ errCurrentPwd && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                />
                                {errCurrentPwd ? <p className="form-error-label">{errMsgInvalidPwd}</p> : null}
                            </Paper>
                        </Grid>
                        <Grid xs={12} item>
                            <Paper className="paper" >
                                <p className="text-input-label">New password</p>
                                <FilledInput 
                                id="new_password" 
                                className="form-text-input" 
                                type="password" variant="outlined"
                                value={newPassword}
                                onChange={passwordHandleChange('newpwd')}
                                data-testid='new_password'  
                                />
                            </Paper>
                        </Grid>
                        <Grid xs={12} item className="no-padding-top no-padding-bottom">
                            <label className="gray-light-label">Password must contain the following:</label>
                            <ul className="signup-list">
                            <li className="gray-light-label"><FontAwesomeIcon icon={validLen ? faCheckCircle : faTimesCircle} className={validLen ? "successful-icon" : "error-icon"} /> At least 8 characters</li>
                            <li className="gray-light-label"><FontAwesomeIcon icon={validNum ? faCheckCircle : faTimesCircle} className={validNum ? "successful-icon" : "error-icon"} /> Include a number</li>
                            <li className="gray-light-label"><FontAwesomeIcon icon={validUpper ? faCheckCircle : faTimesCircle} className={validUpper ? "successful-icon" : "error-icon"} /> Include an upper case character</li>
                            <li className="gray-light-label"><FontAwesomeIcon icon={validLower ? faCheckCircle : faTimesCircle} className={validLower ? "successful-icon" : "error-icon"} /> Include a lower case character</li>
                            <li className="gray-light-label"><FontAwesomeIcon icon={validSpecialCh ? faCheckCircle : faTimesCircle} className={validSpecialCh ? "successful-icon" : "error-icon"} /> Include a special character</li>
                            </ul>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} item className="no-padding-bottom">
                    <Paper className="paper" style={{ textAlign: 'right' }} >
                        <Button type="reset" variant="outlined" id="cancel_btn1" data-testid="cancel_pwd_btn" className="cancel-btn" onClick={() => { clearPasswordForm() }}>
                        Cancel</Button>&nbsp;&nbsp;
                        <Button 
                            type="submit" 
                            variant="outlined" 
                            id="save_btn1" 
                            data-testid="save_pwd_btn" 
                            className="blue-btn font-14"
                            disabled={ 
                                ((firstName === '' || lastName === '') || ( newPassword !== '' && !validPwd)
                                || ( currentPassword !== '' && newPassword === '') || ( newPassword !== '' && currentPassword === '') ) ? true : false}
                        >
                        Save</Button>
                    </Paper>
                </Grid>
              </Grid>
            </form>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default MyProfile
//End SignIn component code ...